import { apolloClient } from "@/plugins/vue-apollo.js";

const createLandlordPlan = async _variables => {
  try {
    const responseFromApi = await apolloClient.mutate({
      mutation: require("@/plans/api/mutations/create_landlord_plan.graphql"),
      variables: {
        input: _variables
      },
    });

    return responseFromApi;
  } catch (error) {
    return error;
  }
};

export { createLandlordPlan };
